import { oauthDetailsPublicVASOO } from './oauth-details.js'
import renderer from './render-vasoo.js'
import './render-vasoo.css'
import init from './init.js'

window.addEventListener('DOMContentLoaded', async () =>
  init(renderer, oauthDetailsPublicVASOO))
